export enum DisplayGroupId {
	bodyPanel,
	bodyPanelForms,
	bottomPanel,
	columnContainer,
	leftPanel,
	pageContainer,
	rowContainer,
	topPanel,
}

export enum PlaceholdersId {
	accessDenied,
	accountSelector,
	authenticatorFooter,
	conclusion,
	corporateData,
	fixedFooter,
	integratorData,
	intro,
	lateralMenu,
	modals,
	paymentOptions,
	requestContact,
	resumeAndAuthorization,
	serviceError,
	termsAndConditions,
}
